module.exports = __webpack_public_path__ + "static/media/home4.6a2b58ed.png";